import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "page-content-block__title-wrapper" }
const _hoisted_2 = { class: "page-content-block__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, {
        class: "page-content-block__header",
        height: _ctx.headerHeight
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1 /* TEXT */),
            _renderSlot(_ctx.$slots, "header-action")
          ]),
          (_ctx.tagStatus)
            ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 0,
                type: _ctx.tagStatusType
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tagStatus), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["type"]))
            : _createCommentVNode("v-if", true),
          (_ctx.subtitle)
            ? (_openBlock(), _createBlock(_component_el_text, {
                key: 1,
                class: "page-content-block__subtitle",
                type: "info"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.subtitle), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["height"]),
      _createVNode(_component_el_main, { class: "page-content-block__main" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "block-content")
        ]),
        _: 3 /* FORWARDED */
      })
    ]),
    _: 3 /* FORWARDED */
  }))
}